import { render, staticRenderFns } from "./CarNewButton.vue?vue&type=template&id=9fccefd0&scoped=true&"
import script from "./CarNewButton.vue?vue&type=script&lang=ts&"
export * from "./CarNewButton.vue?vue&type=script&lang=ts&"
import style0 from "./CarNewButton.vue?vue&type=style&index=0&id=9fccefd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fccefd0",
  null
  
)

export default component.exports